import { SecondaryComponent } from "@/features/secondary"
import { useAuth } from "@/contexts"

// Secondary Fund payment center — available to every logged-in client (the
// component renders an empty state for clients with no secondary deals).
export const SecondaryPage = () => {
  const { user } = useAuth()

  if (!user) return null

  return <SecondaryComponent />
}
